import commonUtil from '../../../../../utils/commonUtil';

export const MASTER_PAGE_LOAD = 'MASTER_PAGE_LOAD';
export const MASTER_PAGE_LOAD_SUCCESS = 'MASTER_PAGE_LOAD_SUCCESS';
export const MASTER_PAGE_LOAD_FAIL = 'MASTER_PAGE_LOAD_FAIL';

export function isMasterPageLoaded(globalState) {
  return globalState.MasterPage && globalState.MasterPage.loaded;
}

export function loadMasterPage() {
  const _labelInput = {};
  _labelInput.brand = commonUtil.getBrand();
  _labelInput.channel = commonUtil.getChannel();
  _labelInput.pageNames = ['home', 'EventDataLandingPage'];
  return {
    types: [MASTER_PAGE_LOAD, MASTER_PAGE_LOAD_SUCCESS, MASTER_PAGE_LOAD_FAIL],
    // promise: client => client.get('/api/registeredGiftList'), // params not used, just shown as demonstration
    promise: client => client.post('/api/masterPage', {
      data: (_labelInput),
    }),
  };
}
